export default __webpack_public_path__ + "static/media/user-profile.fa1d3436.svg";